import { PerformanceRatingsEnum } from "@features/enums/performance-ratings-enum";
import { RatingWithTrim } from "@shared/models/fans/rating-with-trim";

export class PerformanceRankingPuck {

  sequenceNo!: number;
  performanceItemId?: string;
  name!: string;
  performanceName!: string;
  performerNameList!: string[];
  performanceItemRankingid?: string;
  ranked!: boolean;
  locked!: boolean;
  performanceItemRatingid?: string;
  rating?: RatingWithTrim;

  constructor(
    sequenceNo: number,
    performanceItemId: string | undefined,
    name: string,
    performanceName: string,
    performerNameList: string[],
    performanceItemRankingid: string | undefined = undefined,
    ranked: boolean = false,
    locked: boolean = false,
    performanceItemRatingid: string | undefined = undefined,
    rating: RatingWithTrim | undefined = undefined
  ) { 
    this.sequenceNo = sequenceNo;
    this.performanceItemId = performanceItemId;
    this.name = name;
    this.performanceName = performanceName;
    this.performerNameList = performerNameList;
    this.performanceItemRankingid = performanceItemRankingid;
    this.ranked = ranked;
    this.locked = locked;
    this.performanceItemRatingid = performanceItemRatingid;
    this.rating = rating; 
  }
}